<template>
  <div class="v-application--is-ltr">
    <div class="modal__camera-template-wrapper">
        <div v-if="descriptionTop" class="modal__description modal__camera-desc" v-html="descriptionTop"></div>
        <div v-if="loading" class="camera-loading">
          <v-progress-circular
            indeterminate
            color="secondary"
            size="50"
          ></v-progress-circular>
        </div>
        <div v-else-if="staticParams.CAMS_VIEW_ENABLE" class="modal__camera-content">
          <div v-if="cameraImages && cameraImages.length && modalData.preview" 
            class="modal__camera-slider">
              <v-carousel
                  :continuous="false"
                  hide-delimiters
                  theme="dark"
                  height="auto"
                  color="secondary"
                  class="modal__camera-image-list"
              >
                  <v-carousel-item
                      eager
                      v-for="item in cameraImages"
                      :key="item.index"
                      class="modal__camera-image-item"
                  >
                    <div class="modal__camera-image-box">
                        <!-- <img
                          v-if="modalData.name === 'slider-test'"
                          :src="require('@/assets/img/test/' + item.name)"
                        >
                        <div v-else>
                        </div> -->
                        <img v-if="item.code" :src="`data:${item.mime_type};base64,${item.code}`">
                    </div>
                    <div v-if="item.code && item.date_time" class="modal__camera-datetime">{{ formatDate(item.date_time) }}</div>
                  </v-carousel-item>
              </v-carousel>
          </div>
          <div v-else class="modal__camera-image-off">
              <i class="mdi mdi-eye-off"></i>
              <div class="modal__camera-image-off-text">
                <translated-text-component translation="modal_camera_no_image_text" />
              </div>
          </div>
        </div> 
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import { baseApiUrl }    from '@/services/AppConst';
import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import moment from 'moment';

const TemplateModalCamera: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalCamera',
  setup(props) {
    const modalData: Ref<object> = ref({});
    const descriptionTop = ref('');
    const apiUrl = baseApiUrl;
    const cameraImages = ref([]);
    const loading: Ref<boolean> = ref(true);
    const {staticParams} = store.state.settings;

    const getCameraImagesData = (id: number) =>  {
        return ApiService.fetchCameraImagesData(id)
            .then((res: AxiosResponse<any>) => {
                return res.data;
            })
            .catch((reason => console.error(reason)));
    };

    const formatDate = (date: string) => {
      return moment.utc(date).local().format("YYYY-MM-DD HH:mm");
    };


    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;
      descriptionTop.value = metaData.description;

      getCameraImagesData(metaData.id)
        .then(response => {
          if (response?.data) {
              cameraImages.value = response.data[0].images;
          }
          loading.value = false;
        })
        .catch((error) => {
          console.error('Error fetching camera details:', error);
          loading.value = false;
        }); 
    });

    return {
      modalData,
      descriptionTop,
      cameraImages,
      loading,
      formatDate,
      apiUrl,
      staticParams
    };
  },
});
export default TemplateModalCamera;
</script>

<style lang="scss">

.modal__camera {
  &-template-wrapper {
    text-align: center;
  }

  &-description {
    margin-bottom: rem(20px);
    font-size: rem(13px);
  }

  &-desc {
    text-align: center!important;
  }

  &-image-box {
    img {
      .dark-theme & {
        border: 1px solid $yellow-static;
      }
    }
  }

  &-image-off {
    max-width: rem(320px);
    margin: 0 auto;
    background-color: $image-off-bg;
    color: $image-off-font;
    padding: rem(14px) 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
      font-size: rem(110px);
      line-height: 1.1;
    }

    &-text {
      font-weight: 500;
    }
  }
    &-image {
        &-box {
          min-height: rem(50px);

          img {
              max-width: 100%;
          }
        }
    }
}

</style>
